/**
 * @fileoverview GET handler for the "/offerfit/:app_group_id/use_cases/:use_case_id/unpromoted_customer_changes" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { offerfitAppGroupIdUseCasesUseCaseIdUnpromotedCustomerChanges } from "./constants";
import type {
  GetOfferfitAppGroupIdUseCasesUseCaseIdUnpromotedCustomerChangesParams,
  OfferfitAppGroupIdUseCasesUseCaseIdUnpromotedCustomerChangesResult,
} from "./types";
import { isOfferfitAppGroupIdUseCasesUseCaseIdUnpromotedCustomerChangesResult } from "./validators";

export const getOfferfitAppGroupIdUseCasesUseCaseIdUnpromotedCustomerChanges = reactQueryFetcherAdapter(
  offerfitAppGroupIdUseCasesUseCaseIdUnpromotedCustomerChanges,
  (
    signal: AbortSignal,
    { appGroupId, useCaseId }: GetOfferfitAppGroupIdUseCasesUseCaseIdUnpromotedCustomerChangesParams
  ): Promise<OfferfitAppGroupIdUseCasesUseCaseIdUnpromotedCustomerChangesResult> => {
    return fetch(
      `/offerfit/${appGroupId}/use_cases/${useCaseId}/unpromoted_customer_changes`,
      "GET",
      undefined,
      { signal },
      // The banner it drives is information only, so a failed read shows no error modal.
      { propagateFetchRequestError: false }
    );
  },
  isOfferfitAppGroupIdUseCasesUseCaseIdUnpromotedCustomerChangesResult
);
